import './SortOrder.scss'

import { SortOrderPropsType } from '../SortbarTypes'

export function SortOrder({ displaySortOrder, translations }: SortOrderPropsType) {
  return displaySortOrder && <span className="cmp-sortbar__sort-order-label">{translations?.sortedByLabel}</span>
}
